export const ENABLE_UNIT_CLUSTERING_ON_MAP = 'ENABLE_UNIT_CLUSTERING_ON_MAP';
export const CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP =
    'CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP';
export const USER_DRAG_AND_DROP_DISPATCH = 'USER_DRAG_AND_DROP_DISPATCH';
export const FOCUS_EVENT_PANEL_ON_E911_CALL = 'FOCUS_EVENT_PANEL_ON_E911_CALL';
export const DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP = 'DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP';
export const CAD_SECTIONS_DIVIDER_MARGIN = '10px 0';
export const FIRST_RESPONDER_MAP_SELF_FOCUS = 'FIRST_RESPONDER_MAP_SELF_FOCUS';

export const CAD_QUEUES_WINDOW_PREFERENCES = [
    USER_DRAG_AND_DROP_DISPATCH,
    CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP,
];

export const CAD_EVENTS_WINDOW_PREFERENCES = [FOCUS_EVENT_PANEL_ON_E911_CALL];

export const CAD_MAP_WINDOW_PREFERENCES = [ENABLE_UNIT_CLUSTERING_ON_MAP];

export const DEPENDENT_PREFERENCES = [CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP];

export const FR_MAP_SECTION_PREFERENCES = [
    ENABLE_UNIT_CLUSTERING_ON_MAP,
    FIRST_RESPONDER_MAP_SELF_FOCUS,
];

export const DEFAULT_MAP_VIEW_PREFERENCE_LOADING_DELAY = 500;

export const FIRST_RESPONDER_LIGHT_MODE_ENABLED = ['FIRST_RESPONDER_LIGHT_MODE_ENABLED'];
export const CAD_LIGHT_MODE_ENABLED = ['CAD_LIGHT_MODE_ENABLED'];

export const SEARCH_WINDOWS_PREFERENCES = [
    'DEFAULT_FUZZY_MATCHING_ENABLED',
    'DEFAULT_INCLUDE_ACTIVE_ENABLED',
];
